// ContactSection.tsx v2.1 (Force Update)
import React, { FormEvent, useState } from 'react';

export const ContactSection: React.FC = () => {
  const [formData, setFormData] = useState({
    company: '',
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
      const response = await fetch('/mail.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      
      alert('お問い合わせありがとうございます。担当者より折り返しご連絡いたします。');
      // フォームをリセット
      setFormData({
        company: '',
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
      });
    } catch (err) {
      setError('送信に失敗しました。しばらくしてからもう一度お試しください。');
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <section id="contact" className="contact">
      <div className="container">
        <h2 className="section-title">お問い合わせ</h2>
        <div className="contact-content">
          <div className="contact-info">
            <h3>導入のご相談はお気軽に</h3>
            <p>
              WiCanvasの導入に関するご質問やご相談は、専門スタッフが丁寧にサポートいたします。お客様のニーズに最適なソリューションをご提案させていただきます。
            </p>
          </div>
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="company">会社名</label>
              <input
                type="text"
                id="company"
                name="company"
                value={formData.company}
                onChange={handleChange}
              />
            </div>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="name">
                  お名前 <span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">
                  メールアドレス <span className="required">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="phone">電話番号</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="subject">お問い合わせ種別</label>
              <select
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
              >
                <option value="">選択してください</option>
                <option value="製品について">製品について</option>
                <option value="デモンストレーション">デモンストレーション</option>
                <option value="お見積り">お見積り</option>
                <option value="サポート">サポート</option>
                <option value="その他">その他</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="message">
                お問い合わせ内容 <span className="required">*</span>
              </label>
              <textarea
                id="message"
                name="message"
                rows={5}
                value={formData.message}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group form-notice">
              <p>
                ご入力いただいた個人情報は、当社の<a href="https://www.jato.co.jp/p_policy/" target="_blank" rel="noopener noreferrer">プライバシーポリシー</a>に基づき適切に管理いたします。内容をご確認の上、送信してください。
              </p>
            </div>
            <button type="submit" className="btn btn-primary btn-large" disabled={isSubmitting}>
              {isSubmitting ? '送信中...' : '送信する'}
            </button>
            {error && <p className="error-message">{error}</p>}
          </form>
        </div>
      </div>
    </section>
  );
};
